/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Kindle_Docked_PlayerInputs */

const en_mobile_kindle_docked_player = /** @type {(inputs: Mobile_Kindle_Docked_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docked Kindle player`)
};

const es_mobile_kindle_docked_player = /** @type {(inputs: Mobile_Kindle_Docked_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproductor Kindle acoplado`)
};

/**
* | output |
* | --- |
* | "Docked Kindle player" |
*
* @param {Mobile_Kindle_Docked_PlayerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_kindle_docked_player = /** @type {((inputs?: Mobile_Kindle_Docked_PlayerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Kindle_Docked_PlayerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_kindle_docked_player(inputs)
	return en_mobile_kindle_docked_player(inputs)
});